<template>
  <Doughnut
    id="my-chart-id"
    :options="chartOptions"
    :data="data"
  />
</template>

<script>
import { Doughnut } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
import {Chart, ArcElement} from 'chart.js'
Chart.register(ArcElement);

export default {
   props: ["data"],
  name: 'DoughnutChart',
  components: { Doughnut },
   mounted(){
    console.log(this.data);
    },
  data() {
    return {
      chartData: {
        labels: [ 'January', 'February', 'March' ],
        datasets: [ { data: [40, 20, 12] } ]
      },
      chartOptions: {
        responsive: true
      }
    }
  }
}
</script>